export const extractData = (res) => {
  const { data: { result } } = res;
  return result;
};
